(function () {
  'use strict';

  if (window.__rgSeptemberGiveawayInitialized) return;
  window.__rgSeptemberGiveawayInitialized = true;

  var CAMPAIGN = 'September 2026';
  var METRIC_NAME = 'RGM Giveaway Entry';
  var PENDING_STORAGE_KEY = 'rgSeptemberGiveawayPending2026';
  var API_REVISION = '2026-07-15';

  function safeJsonParse(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function getPendingEntry() {
    try {
      return safeJsonParse(localStorage.getItem(PENDING_STORAGE_KEY)) || safeJsonParse(sessionStorage.getItem(PENDING_STORAGE_KEY));
    } catch (error) {
      try {
        return safeJsonParse(sessionStorage.getItem(PENDING_STORAGE_KEY));
      } catch (sessionError) {
        return null;
      }
    }
  }

  function setPendingEntry(entry) {
    var saved = false;
    try {
      localStorage.setItem(PENDING_STORAGE_KEY, JSON.stringify(entry));
      saved = true;
    } catch (error) {}
    try {
      sessionStorage.setItem(PENDING_STORAGE_KEY, JSON.stringify(entry));
      saved = true;
    } catch (error) {}
    return saved;
  }

  function clearPendingEntry() {
    try {
      localStorage.removeItem(PENDING_STORAGE_KEY);
    } catch (error) {}
    try {
      sessionStorage.removeItem(PENDING_STORAGE_KEY);
    } catch (error) {}
  }

  function setTrackingStatus(root, message, state) {
    var status = root.querySelector('[data-rg-entry-tracking]');
    if (!status) return;
    status.textContent = message || '';
    status.setAttribute('data-state', state || '');
  }

  function normalizedEmail(value) {
    return String(value || '').trim().toLowerCase().slice(0, 200);
  }

  async function stableEventId(entryType, email) {
    var source = [CAMPAIGN, entryType, normalizedEmail(email)].join('|');
    if (window.crypto && window.crypto.subtle && window.TextEncoder) {
      var digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(source));
      var bytes = new Uint8Array(digest).slice(0, 16);
      bytes[6] = (bytes[6] & 15) | 80;
      bytes[8] = (bytes[8] & 63) | 128;
      var hex = Array.prototype.map.call(bytes, function (byte) {
        return byte.toString(16).padStart(2, '0');
      }).join('');
      return [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join('-');
    }

    var hash = 2166136261;
    for (var index = 0; index < source.length; index += 1) {
      hash ^= source.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    var fallback = (hash >>> 0).toString(16).padStart(8, '0');
    return fallback + '-0000-5000-8000-' + fallback + '0000';
  }

  async function postKlaviyo(root, resource, payload) {
    var companyId = root.getAttribute('data-klaviyo-company-id');
    if (!companyId) throw new Error('Missing Klaviyo company ID');
    var response = await fetch('https://a.klaviyo.com/client/' + resource + '/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: API_REVISION
      },
      body: JSON.stringify(payload),
      keepalive: true
    });
    if (response.status !== 202) throw new Error('Klaviyo returned ' + response.status);
  }

  function profileProperties(entry) {
    var entrySource = entry.entrySource || 'September giveaway page';
    return {
      'RGM Giveaway Campaign': CAMPAIGN,
      'RGM September Giveaway Entered': true,
      'RGM September Giveaway Base Entries': 1,
      'RGM September Giveaway Share Entries': entry.shared ? 5 : 0,
      'RGM September Giveaway Crystal Ascension Entries': entry.crystalAscensionMember ? 5 : 0,
      'RGM September Giveaway Total Entries': entry.totalEntries,
      'RGM September Giveaway Entry Date': entry.entryDate,
      'RGM September Giveaway Entry Source': entrySource
    };
  }

  async function recordEntryEvent(root, entry, entryType, entries) {
    var entrySource = entry.entrySource || 'September giveaway page';
    var eventProperties = {
      Campaign: CAMPAIGN,
      'Entry Type': entryType,
      Entries: entries,
      'Total Claimed Entries': entry.totalEntries,
      'Eligible US 18+': true,
      'Entry Source': entrySource,
      'Entry Date': entry.entryDate
    };
    if (entryType === 'Share bonus') eventProperties['Share Platform'] = entry.sharePlatform || 'Customer confirmed';

    await postKlaviyo(root, 'events', {
      data: {
        type: 'event',
        attributes: {
          properties: eventProperties,
          metric: { data: { type: 'metric', attributes: { name: METRIC_NAME } } },
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: entry.email,
                first_name: entry.firstName,
                last_name: entry.lastName,
                properties: profileProperties(entry)
              }
            }
          },
          time: entry.entryDate,
          unique_id: await stableEventId(entryType, entry.email)
        }
      }
    });
  }

  async function subscribeToEmailList(root, entry) {
    var listId = root.getAttribute('data-klaviyo-list-id');
    if (!listId) throw new Error('Missing Klaviyo list ID');
    await postKlaviyo(root, 'subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Royal Gems September Monthly Giveaway',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: entry.email,
                first_name: entry.firstName,
                last_name: entry.lastName,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    });
  }

  async function finalizePendingEntry(root) {
    var success = root.querySelector('[data-rg-entry-success]');
    var entry = getPendingEntry();
    if (!success || !entry || entry.campaign !== CAMPAIGN || !entry.email) return;

    setTrackingStatus(root, 'Finalizing your permanent entry record…', 'working');
    var eventJobs = [recordEntryEvent(root, entry, 'Email entry', 1)];
    if (entry.shared) eventJobs.push(recordEntryEvent(root, entry, 'Share bonus', 5));
    if (entry.crystalAscensionMember) eventJobs.push(recordEntryEvent(root, entry, 'Crystal Ascension bonus', 5));

    var eventResults = await Promise.allSettled(eventJobs);
    var eventsSaved = eventResults.every(function (result) { return result.status === 'fulfilled'; });
    var subscriptionSaved = false;
    try {
      await subscribeToEmailList(root, entry);
      subscriptionSaved = true;
    } catch (error) {}

    if (eventsSaved && subscriptionSaved) {
      clearPendingEntry();
      setTrackingStatus(root, 'Your permanent entry record is saved. You have ' + entry.totalEntries + ' total entr' + (entry.totalEntries === 1 ? 'y.' : 'ies.'), 'success');
      return;
    }

    if (eventsSaved) {
      setTrackingStatus(root, 'Your giveaway entry is permanently recorded. Your email signup will retry automatically.', 'warning');
    } else {
      setTrackingStatus(root, 'Shopify received your entry. The permanent giveaway record will retry automatically.', 'warning');
    }
    window.setTimeout(function () { finalizePendingEntry(root); }, 5000);
  }

  function getDeadline(root) {
    var rawDeadline = root.getAttribute('data-entry-deadline');
    var deadline = rawDeadline ? new Date(rawDeadline).getTime() : NaN;
    return Number.isFinite(deadline) ? deadline : null;
  }

  function entryIsClosed(root) {
    var deadline = getDeadline(root);
    return deadline !== null && Date.now() >= deadline;
  }

  function showClosedEntryState(root) {
    root.querySelectorAll('form[data-rg-entry-form]').forEach(function (form) {
      var fields = form.querySelector('[data-rg-entry-fields]');
      var closed = form.querySelector('[data-rg-entry-closed]');
      if (fields) fields.hidden = true;
      if (closed) closed.hidden = false;
    });
  }

  function initializeCountdown(root) {
    var countdown = root.querySelector('[data-rg-countdown]');
    var deadline = getDeadline(root);
    if (!countdown || deadline === null) return;

    countdown.textContent = '';
    countdown.setAttribute('role', 'timer');
    countdown.setAttribute('aria-live', 'off');
    countdown.setAttribute('aria-atomic', 'true');

    var label = document.createElement('span');
    label.className = 'rg-september-countdown__label';
    label.textContent = 'Entries close in';
    label.setAttribute('aria-hidden', 'true');
    countdown.appendChild(label);

    var units = document.createElement('span');
    units.className = 'rg-september-countdown__units';
    units.setAttribute('aria-hidden', 'true');
    countdown.appendChild(units);

    var values = {};
    [
      ['days', 'Days'],
      ['hours', 'Hours'],
      ['minutes', 'Minutes'],
      ['seconds', 'Seconds']
    ].forEach(function (definition) {
      var unit = document.createElement('span');
      unit.className = 'rg-september-countdown__unit';

      var value = document.createElement('strong');
      value.className = 'rg-september-countdown__value';
      value.textContent = '--';

      var unitLabel = document.createElement('small');
      unitLabel.textContent = definition[1];

      unit.appendChild(value);
      unit.appendChild(unitLabel);
      units.appendChild(unit);
      values[definition[0]] = value;
    });

    var intervalId = null;

    function setValue(name, value) {
      if (values[name]) values[name].textContent = String(value).padStart(2, '0');
    }

    function update() {
      var remaining = Math.max(0, deadline - Date.now());
      if (remaining <= 0) {
        countdown.textContent = 'Online entries are closed';
        countdown.setAttribute('aria-label', 'Online entries are closed');
        showClosedEntryState(root);
        if (intervalId) window.clearInterval(intervalId);
        return;
      }

      var days = Math.floor(remaining / 86400000);
      var hours = Math.floor((remaining % 86400000) / 3600000);
      var minutes = Math.floor((remaining % 3600000) / 60000);
      var seconds = Math.floor((remaining % 60000) / 1000);

      setValue('days', days);
      setValue('hours', hours);
      setValue('minutes', minutes);
      setValue('seconds', seconds);
      countdown.setAttribute(
        'aria-label',
        days + ' days, ' + hours + ' hours, ' + minutes + ' minutes, and ' + seconds + ' seconds left to enter'
      );
    }

    update();
    if (!entryIsClosed(root)) intervalId = window.setInterval(update, 1000);
  }

  function setShareStatus(button, message) {
    var context = button.closest('form') || button.closest('.rg-september-giveaway__share-card') || button.parentElement;
    var status = context && context.querySelector('[data-rg-share-status]');
    if (status) status.textContent = message;
  }

  function getShareUrl(root) {
    return root.getAttribute('data-giveaway-url') || window.location.href.split('#')[0].split('?')[0];
  }

  function getShareText() {
    return 'Enter the Royal Gems September Monthly Giveaway for a chance to win a $300+ surprise hand selected at the Denver Gem Show!';
  }

  function setBonusConfirmed(form, tag) {
    if (!form) return false;
    var bonus = form.querySelector('[data-rg-bonus-tag="' + tag + '"]');
    if (!bonus) return false;
    bonus.checked = true;
    updateEntryTags(form);
    return true;
  }

  function confirmShareBonus(button, platform, message) {
    var form = button.closest('form');
    if (!form || !setBonusConfirmed(form, 'giveaway-share-confirmed')) {
      setShareStatus(button, message);
      return;
    }
    form.dataset.rgSharePlatform = platform;
    button.classList.add('is-confirmed');
    button.setAttribute('aria-pressed', 'true');
    button.textContent = platform === 'Facebook' ? '✓ Facebook Bonus Added' : '✓ Share Bonus Added';
    setShareStatus(button, message);
  }

  function initializeSharing(root) {
    root.querySelectorAll('[data-rg-share]').forEach(function (button) {
      button.addEventListener('click', async function () {
        var shareUrl = getShareUrl(root);
        var platform = button.getAttribute('data-rg-share');

        if (platform === 'facebook') {
          var shareWindow = window.open(
            'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareUrl),
            'rgSeptemberGiveawayShare',
            'width=720,height=560'
          );
          if (shareWindow) {
            try {
              shareWindow.opener = null;
            } catch (error) {}
            confirmShareBonus(button, 'Facebook', 'Facebook opened. Your five bonus entries are selected.');
          } else {
            setShareStatus(button, 'Please allow the Facebook share window, then try again.');
          }
          return;
        }

        try {
          if (navigator.share) {
            await navigator.share({
              title: 'Royal Gems September Monthly Giveaway',
              text: getShareText(),
              url: shareUrl
            });
            confirmShareBonus(button, 'Device share', 'Thank you for sharing. Your five bonus entries are selected.');
          } else if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(getShareText() + ' ' + shareUrl);
            confirmShareBonus(button, 'Copied link', 'The link is copied. Your five bonus entries are selected.');
          } else {
            var promptResult = window.prompt('Copy this giveaway link:', shareUrl);
            if (promptResult !== null) {
              confirmShareBonus(button, 'Copied link', 'Your five share bonus entries are selected.');
            }
          }
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          setShareStatus(button, 'The link could not be copied automatically. Please copy it from your browser.');
        }
      });
    });
  }

  function initializeMembershipBonus(form) {
    var action = form.querySelector('[data-rg-membership-action]');
    var status = form.querySelector('[data-rg-membership-status]');
    if (!action) return;
    action.addEventListener('click', function () {
      if (!setBonusConfirmed(form, 'crystal-ascension-member')) return;
      action.classList.add('is-confirmed');
      action.textContent = '✓ Crystal Ascension Bonus Added';
      if (status) status.textContent = 'Your five Crystal Ascension bonus entries are selected.';
    });
  }

  function updateEntryTags(form) {
    var tagsInput = form.querySelector('[data-rg-entry-tags]');
    if (!tagsInput) return;

    var baseTags = ['newsletter', 'september-monthly-giveaway-2026', 'giveaway-entry'];
    form.querySelectorAll('[data-rg-bonus-tag]').forEach(function (checkbox) {
      if (checkbox.checked) baseTags.push(checkbox.getAttribute('data-rg-bonus-tag'));
    });
    tagsInput.value = baseTags.join(', ');
  }

  function capturePendingEntry(root, form) {
    var share = form.querySelector('[data-rg-bonus-tag="giveaway-share-confirmed"]');
    var crystal = form.querySelector('[data-rg-bonus-tag="crystal-ascension-member"]');
    var entry = {
      campaign: CAMPAIGN,
      firstName: form.querySelector('[name="contact[first_name]"]').value.trim().slice(0, 80),
      lastName: form.querySelector('[name="contact[last_name]"]').value.trim().slice(0, 80),
      email: normalizedEmail(form.querySelector('[name="contact[email]"]').value),
      entryDate: new Date().toISOString(),
      entrySource: root.getAttribute('data-entry-source') || 'September giveaway page',
      shared: Boolean(share && share.checked),
      sharePlatform: form.dataset.rgSharePlatform || 'Customer confirmed',
      crystalAscensionMember: Boolean(crystal && crystal.checked)
    };
    entry.totalEntries = 1 + (entry.shared ? 5 : 0) + (entry.crystalAscensionMember ? 5 : 0);

    var body = form.querySelector('[data-rg-entry-body]');
    if (body) {
      body.value = [
        'September 2026 Monthly Giveaway entry.',
        'Email entry: 1',
        'Share bonus entries: ' + (entry.shared ? 5 : 0),
        'Crystal Ascension bonus entries: ' + (entry.crystalAscensionMember ? 5 : 0),
        'Total entries claimed: ' + entry.totalEntries,
        'Entry source: ' + entry.entrySource,
        'Share platform: ' + (entry.shared ? entry.sharePlatform : 'Not claimed')
      ].join('\n');
    }
    setPendingEntry(entry);
  }

  function initializeEntryForm(root, form) {
    form.setAttribute('data-rg-entry-form', '');

    if (entryIsClosed(root)) {
      showClosedEntryState(root);
      return;
    }

    initializeMembershipBonus(form);

    form.querySelectorAll('[data-rg-bonus-tag]').forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        updateEntryTags(form);
      });
    });

    form.addEventListener('submit', function (event) {
      if (entryIsClosed(root)) {
        event.preventDefault();
        showClosedEntryState(root);
        return;
      }

      updateEntryTags(form);
      capturePendingEntry(root, form);
      var submit = form.querySelector('[data-rg-entry-submit]');
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Submitting your entry…';
      }
    });
  }

  function initializeRoot(root) {
    initializeCountdown(root);
    initializeSharing(root);
    root.querySelectorAll('.rg-september-giveaway-form').forEach(function (form) {
      initializeEntryForm(root, form);
    });

    var feedback = root.querySelector('[data-rg-entry-success], [data-rg-entry-errors]');
    if (feedback) {
      window.setTimeout(function () {
        feedback.focus();
      }, 50);
    }
    finalizePendingEntry(root);
  }

  document.querySelectorAll('[data-rg-september-giveaway]').forEach(initializeRoot);
})();
